import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { IMiscSlice } from './types';

const initialState: IMiscSlice = {
  isDbooProfileUpdated: false,
  isWatchlistProfileUpdated: false,
  isDataCollectionModalClosed: false,
  isDataCollectionBannerClosed: false,
  cardExpiryModalRequested: false,
  cardExpiryModalSkipToPayment: false,
};

const miscSlice = createAppSlice({
  name: 'misc',
  initialState,
  reducers: {
    setIsDbooProfileUpdated(state, action: PayloadAction<boolean>) {
      state.isDbooProfileUpdated = action.payload;
    },
    setIsWatchlistProfileUpdated(state, action: PayloadAction<boolean>) {
      state.isWatchlistProfileUpdated = action.payload;
    },
    setIsDataCollectionModalClosed(state, action: PayloadAction<boolean>) {
      state.isDataCollectionModalClosed = action.payload;
    },
    setDataCollectionBannerClosed(state, action: PayloadAction<boolean>) {
      state.isDataCollectionBannerClosed = action.payload;
    },
    setCardExpiryModalRequested(state, action: PayloadAction<boolean>) {
      state.cardExpiryModalRequested = action.payload;
      /* Auto-clear the skip-to-payment flag whenever the request
       * flag is cleared, so a subsequent auto-trigger doesn't
       * inherit a stale "jump to Zuora" instruction. */
      if (!action.payload) state.cardExpiryModalSkipToPayment = false;
    },
    /* Angular parity — `data.showZuoraForm` on the popup.
     * Set alongside `cardExpiryModalRequested = true` by the
     * Discover proprietary banner click; the modal reads it once
     * on open and jumps straight to the Zuora iframe. */
    requestCardExpiryModalOnPayment(state) {
      state.cardExpiryModalRequested = true;
      state.cardExpiryModalSkipToPayment = true;
    },
  },
});

export const {
  setIsDbooProfileUpdated,
  setIsWatchlistProfileUpdated,
  setIsDataCollectionModalClosed,
  setDataCollectionBannerClosed,
  setCardExpiryModalRequested,
  requestCardExpiryModalOnPayment,
} = miscSlice.actions;
export default miscSlice.reducer;
